import { render, staticRenderFns } from "./objectselector.vue?vue&type=template&id=76a9e928"
import script from "./objectselector.vue?vue&type=script&lang=ts"
export * from "./objectselector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports